if (!customElements.get("m-sharing")) {
  customElements.define(
    "m-sharing",
    class MSharing extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector("[data-open-share]");
        const shareContent = this.querySelector(".m-product-addon--sharing");

        if (!this.openButton || !shareContent?.innerHTML) return;

        this.shareContent = shareContent.innerHTML;
        this.modal = new MinimogTheme.Modal();
        this.handleOpen = this.open.bind(this);
        this.openButton.addEventListener("click", this.handleOpen);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener("click", this.handleOpen);
        clearTimeout(this.copyTimer);
      }

      open(event) {
        event.preventDefault();

        const content = document.createElement("div");
        content.className = "m-sharing__content";
        content.innerHTML = this.shareContent;

        this.modal.appendChild(content);
        const colorScheme =
          content.querySelector("[data-color-scheme]")?.dataset.colorScheme || "";

        this.modal.setSizes(`m-sharing tanatel-sharing-modal m-gradient ${colorScheme}`);
        this.bindCopyButton(content);
        this.modal.open();
      }

      bindCopyButton(content) {
        const button = content.querySelector("[data-share-copy]");
        const input = content.querySelector("[data-share-url]");
        const status = content.querySelector("[data-share-status]");

        if (!button || !input) return;

        button.addEventListener("click", async () => {
          const copied = await this.copyText(input);
          if (!copied) return;

          const label = button.querySelector("span");
          const copiedLabel = button.dataset.copiedLabel || "Copied";

          button.classList.add("is-copied");
          if (label) label.textContent = copiedLabel;
          if (status) status.textContent = copiedLabel;

          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => {
            button.classList.remove("is-copied");
            if (label) {
              label.textContent = button.dataset.defaultLabel || "Copy link";
            }
            if (status) status.textContent = "";
          }, 1800);
        });
      }

      async copyText(input) {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(input.value);
            return true;
          }

          input.removeAttribute("readonly");
          input.select();
          input.setSelectionRange(0, input.value.length);
          const copied = document.execCommand("copy");
          input.setAttribute("readonly", "");
          window.getSelection()?.removeAllRanges();
          return copied;
        } catch (error) {
          input.setAttribute("readonly", "");
          return false;
        }
      }
    },
  );
}
